import DlAnimate from 'dl-animate/dist/dl-animate-module';
import { TweenLite, TweenMax } from 'gsap/TweenMax';
import toggleModal from '@/scripts/utils/toggle-modal';
import { DOCUMENT_ELEMENT } from '@/scripts/constants';
import detectMobile from '@/scripts/utils/detect-mobile';

const dlAnimate = new DlAnimate();
const defaults = {
  menuSelector: '[data-role="menu"]', // .menu,
  menuContainer: '[data-role="menu-list-container"]', // .menu__container inner
  menuScrollElement: '[data-role="menu-scroll-element"]', // .menu__container inner
  menuWrapper: '[data-role="menu-wrapper"]', // .menu__wrapper outer
  menuList: 'ul',
  menuListItem: 'li',
  menuItemDecoration: '[data-role="menu-item-decorator"]', // .line
  menuTrigger: '[data-role="menu-trigger"]',
  transitionDuration: 450,
};
export default class HeaderNav {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.menuSelector = options.menuSelector;
    this.menu = document.querySelector(options.menuSelector);
    this.menuTrigger = document.querySelectorAll(options.menuTrigger);
    this.menuContainer = this.menu.querySelector(options.menuContainer); // inner
    this.menuWrapperSelector = options.menuWrapper; // outer
    this.menuScrollElement = options.menuScrollElement;
    this.menuListSelector = options.menuList;
    this.menuList = this.menuContainer.querySelector(options.menuList);
    this.menuListItemSelector = options.menuListItem;
    this.transitionDuration = options.transitionDuration;
    this.previousSubMenuList = null;
    this.previousSubMenuLink = null;

    if (options.menuItemDecoration) {
      this.menuItemDecoration = options.menuItemDecoration;
    }

    // helpers
    this.openedClass = 'menu-opened';
    this.hiddenClass = 'is-hidden';
    this.disabledClass = 'id-disabled';

    this.init();
  }

  closeSubMenu(link) {
    if (this.previousSubMenuList) {
      link.classList.remove('active');
      this.menuContainer.classList.remove('active-submenu');
      if (!detectMobile()) {
        TweenMax.to(this.previousSubMenuList, 0.4, { autoAlpha: 0 });
      } else {
        dlAnimate.hide(this.previousSubMenuList, {
          name: 'menu',
          track: 'none',
          duration: this.transitionDuration,
        });
      }
      this.previousSubMenuList = null;
      this.previousSubMenuLink = null;
    }
  }

  openInnerClick(e, link) {
    this.scrollToTop();
    this.reInit();
    const item = e.target.closest(this.menuListItemSelector) || e.target;
    const list = item.querySelector(this.menuListSelector);

    if (this.previousSubMenuLink !== link) {
      link.classList.add('active');
      this.menuContainer.classList.add('active-submenu');
      if (this.previousSubMenuList) {
        this.previousSubMenuLink.classList.remove('active');
        dlAnimate.hide(this.previousSubMenuList, {
          name: 'menu',
          track: 'none',
          duration: this.transitionDuration,
          afterLeave: () => {
            dlAnimate.show(list, { name: 'menu' });
          },
        });
      } else {
        dlAnimate.show(list, { name: 'menu' });
      }
      this.previousSubMenuList = list;
      this.previousSubMenuLink = link;
    } else {
      this.closeSubMenu(link);
    }
  }

  openSubMenuHover(e, link) {
    this.scrollToTop();
    this.reInit();
    const item = e.target.closest(this.menuListItemSelector) || e.target;
    const list = item.querySelector(this.menuListSelector);

    link.classList.add('active');
    this.menuContainer.classList.add('active-submenu');
    TweenMax.to(list, 0.4, { autoAlpha: 1 });
    this.previousSubMenuList = list;
    this.previousSubMenuLink = link;
  }

  toggleStatus() {
    this.scrollToTop();
    DOCUMENT_ELEMENT.classList.toggle(this.openedClass);
    return toggleModal(DOCUMENT_ELEMENT.classList.contains(this.openedClass), this.menuScrollElement, this.menu);
  }

  scrollToTop() {
    return TweenLite.to(
      this.menu,
      this.transitionDuration / 1000,
      { scrollTo: { y: 0, autoKill: false } },
    );
  }

  refreshList(list) {
    const that = this;
    list.classList.add('top-list');
    Array.from(list.children).forEach((el) => {
      el.classList.add('top-item');
      if (el.classList.contains('has-children')) {
        if (!detectMobile()) {
          el.addEventListener('mouseenter', function (e) {
            that.closeSubMenu(this);
            that.openSubMenuHover(e, this);
          });
          el.addEventListener('mouseleave', function () {
            that.closeSubMenu(this);
          });
        } else {
          el.addEventListener('click', function (e) {
            that.openInnerClick(e, this);
          });
        }
      }
    });
  }

  init() {
    const that = this;
    this.refreshList(this.menuList);
    detectMobile() ? this.menuContainer.classList.add('mobile-menu') : this.menuContainer.classList.add('desktop-menu'); // eslint-disable-line no-unused-expressions

    Array.from(this.menuTrigger).forEach(trigger => trigger.addEventListener('click', this.toggleStatus.bind(this), false));
    document.addEventListener('click', (e) => {
      if (!e.target.closest(this.menuWrapperSelector)
        && DOCUMENT_ELEMENT.classList.contains(this.openedClass)) {
        this.toggleStatus();
      }
    });
    if (detectMobile()) {
      document.addEventListener('click', (e) => {
        if (!e.target.closest(this.menuSelector)) {
          that.closeSubMenu(this.previousSubMenuLink);
        } else {
          e.stopPropagation();
        }
      });
    }
  }

  reInit() {
    this.menuList = this.menuContainer.querySelector(this.menuListSelector);
  }
}



// WEBPACK FOOTER //
// ./scripts/elements/header-nav.js